import { StepIds } from '../models/motors-step/motors-step-model';
import {
    StepDisabledStates,
    StepModel,
    StepTouchedStates,
    StepValidityStates,
    StepVisibilityStates
} from '@classifieds-sell/shared';

export const MOTORS_DEFAULT_STEP_STRUCTURE = [
    new StepModel(
        StepIds.vehicleDetails,
        'Vehicle details',
        StepDisabledStates.enabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    ),
    new StepModel(
        StepIds.listingDetails,
        'Listing details',
        StepDisabledStates.disabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    ),
    new StepModel(
        StepIds.descriptionAndPhotos,
        'Description & photos',
        StepDisabledStates.disabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    ),
    new StepModel(
        StepIds.summary,
        'Summary',
        StepDisabledStates.disabled,
        StepValidityStates.invalid,
        StepTouchedStates.untouched,
        StepVisibilityStates.visible
    )
];
